import { render, staticRenderFns } from "./unreadInternalMessage.vue?vue&type=template&id=6158db3d&scoped=true&"
import script from "./unreadInternalMessage.vue?vue&type=script&lang=js&"
export * from "./unreadInternalMessage.vue?vue&type=script&lang=js&"
import style0 from "./unreadInternalMessage.vue?vue&type=style&index=0&id=6158db3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6158db3d",
  null
  
)

export default component.exports